export default {"src":"/_next/static/media/carins.95dbaf81.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};